<!-- svelte-ignore a11y-no-redundant-roles -->
<footer role="contentinfo">
  <p class="footer-styles-ipg ">Copyright (c) 2017 Klaus Nothnagel</p>
  <p class="footer-styles-ipg ">All Rights Reserved.</p>
</footer>


<style>
  footer {
    margin: 10px 0 0;
    padding: 15px;
    border-top: 1px solid black;
    font-size: .8rem;
  }

  footer > p {
    margin: 0;
  }
</style>